import clsx from 'clsx'
import {HeaderUserMenu, ThemeModeSwitcher} from '../../../partials'
import {useSelector} from "react-redux";
import {RootState} from "../../../../app/core/store/store.ts";

const itemClass = 'ms-1 ms-md-4'
const userAvatarClass = 'symbol-35px'

const Navbar = () => {
  const userMe = useSelector((state: RootState) => state.userMe)

  return (
    <div className='app-navbar flex-shrink-0'>
      {/*<div className={clsx('app-navbar-item align-items-stretch', itemClass)}>*/}
      {/*  <Search />*/}
      {/*</div>*/}

      {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
      {/*  <div*/}
      {/*    data-kt-menu-trigger="{default: 'click'}"*/}
      {/*    data-kt-menu-attach='parent'*/}
      {/*    data-kt-menu-placement='bottom-end'*/}
      {/*    className={btnClass}*/}
      {/*  >*/}
      {/*    <KTIcon iconName='element-plus' className={btnIconClass}/>*/}
      {/*  </div>*/}
      {/*  <HeaderNotificationsMenu/>*/}
      {/*</div>*/}

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img src={userMe?.profileImage} alt='' />
        </div>

        <HeaderUserMenu />
      </div>
    </div>
  )
}

export {Navbar}
